// PostDetailでuidからユーザー名を取得するためのフック
import { useEffect, useState } from 'react';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { getFirebaseApp } from '../firebase/firebaseConfig';

export function useUserDisplayName(uid) {
  const [displayName, setDisplayName] = useState('');
  useEffect(() => {
    if (!uid) return;
    const db = getFirestore(getFirebaseApp());
    getDoc(doc(db, 'users', uid)).then(snap => {
      setDisplayName(snap.exists() ? snap.data().displayName || '' : '');
    });
  }, [uid]);
  return displayName;
}
